import { AppCookies } from '@enums/cookies';
import useWelcomeVoucherQuery from '@hooks/user/use-welcome-voucher-query';
import { useEffect, useMemo, useState } from 'react';
import Cookies from 'universal-cookie';
import Environment from '@config/environment';

const usePdpWelcomeVoucherQuery = (
  productId: string,
  isRecirculation: boolean,
  showPdpBanner: boolean,
  isWelcomeOfferLDFlagEnabled: boolean,
) => {
  const [bannerClosed, setBannerClosed] = useState<boolean>(false);
  const [showBanner, setShowBanner] = useState(showPdpBanner);
  const { welcomeVoucher } = useWelcomeVoucherQuery({ touchPoint: 'PDP', productId });

  const displayPdpTopBanner = useMemo(() => {
    return showBanner && welcomeVoucher?.text && !isRecirculation;
  }, [showBanner, welcomeVoucher?.text, isRecirculation, showPdpBanner]);

  useEffect(() => {
    setShowBanner(!bannerClosed && showPdpBanner);
  }, [bannerClosed, showPdpBanner]);

  // this useEffect is to show the banner only on page reload or new tab as this is product requirement
  useEffect(() => {
    if (isWelcomeOfferLDFlagEnabled) {
      const navigationEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
      const isReload = navigationEntries?.length > 0 && navigationEntries[0]?.type === 'reload';
      const isNewTab = !document.referrer;
      const cookies = new Cookies();
      const promoCookie = cookies.get(AppCookies.PDP_WELCOME_OFFER_CLOSED);
      if (isReload || isNewTab || !promoCookie) {
        setShowBanner(true);
        setBannerClosed(false);
        if (promoCookie) {
          cookies.remove(AppCookies.PDP_WELCOME_OFFER_CLOSED, {
            path: '/',
            domain: Environment.cookieOptions.domain,
          });
        }
      }
    }
  }, []);

  const onCloseBanner = () => {
    setBannerClosed(true);
    const cookies = new Cookies();
    cookies.set(AppCookies.PDP_WELCOME_OFFER_CLOSED, true, {
      path: '/',
      domain: Environment.cookieOptions.domain,
      expires: new Date(Date.now() + 10 * 60 * 1000),
    });
  };

  return {
    bannerText: welcomeVoucher?.text,
    voucherCode: welcomeVoucher?.voucherCode,
    onClose: onCloseBanner,
    setBannerClosed,
    displayPdpTopBanner,
  };
};

export default usePdpWelcomeVoucherQuery;
